module.exports = __webpack_public_path__ + "static/media/empty-state_Illustration.a3867370.svg";